export const API_KEY =
  'pk.eyJ1IjoibnVsbGlzaHkiLCJhIjoiY2p4N3J4M2NmMGRwZDN0bzFtdmtrZWhuZiJ9.hBoKTZHkgoXF_VWi5TxSHw';
